var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"feedback"},[_vm._t("default"),_c('b-form-invalid-feedback',{staticStyle:{"margin":"0"},attrs:{"force-show":_vm.errors !== null}},[_c('ul',_vm._l((_vm.errors),function(error){return _c('li',{key:error},[_vm._v(_vm._s(error))])}),0)])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }